/**
 * Impl dos use cases da CPA (ciclos + lifecycle + relatório; acadadmin).
 *
 * @since G.5.13
 */
import type { Page } from '@/domain/model/Page';
import type {
  CpaCiclo, CpaDimensao, CpaRelatorioSintetico,
  CriarCpaCicloCommand, ProrrogarCpaCicloCommand,
} from '@/domain/model/Cpa';
import type { CpaGateway, ListCpaCiclosParams } from '@/application/port/out/CpaGateway';
import type {
  ListCpaCiclosUseCase, GetCpaCicloUseCase, CriarCpaCicloUseCase,
  AgendarCpaCicloUseCase, ProrrogarCpaCicloUseCase, FecharCpaCicloUseCase,
  ArquivarCpaCicloUseCase, RelatorioSinteticoCpaUseCase, ListCpaDimensoesUseCase,
} from '@/application/port/in/CpaUseCase';

export class ListCpaCiclos implements ListCpaCiclosUseCase {
  constructor(private readonly g: CpaGateway) {}
  execute(params: ListCpaCiclosParams): Promise<Page<CpaCiclo>> { return this.g.list(params); }
}
export class GetCpaCiclo implements GetCpaCicloUseCase {
  constructor(private readonly g: CpaGateway) {}
  execute(id: string): Promise<CpaCiclo> { return this.g.get(id); }
}
export class CriarCpaCiclo implements CriarCpaCicloUseCase {
  constructor(private readonly g: CpaGateway) {}
  execute(cmd: CriarCpaCicloCommand): Promise<CpaCiclo> { return this.g.criar(cmd); }
}
export class AgendarCpaCiclo implements AgendarCpaCicloUseCase {
  constructor(private readonly g: CpaGateway) {}
  execute(id: string): Promise<CpaCiclo> { return this.g.agendar(id); }
}
export class ProrrogarCpaCiclo implements ProrrogarCpaCicloUseCase {
  constructor(private readonly g: CpaGateway) {}
  execute(id: string, cmd: ProrrogarCpaCicloCommand): Promise<CpaCiclo> { return this.g.prorrogar(id, cmd); }
}
export class FecharCpaCiclo implements FecharCpaCicloUseCase {
  constructor(private readonly g: CpaGateway) {}
  execute(id: string): Promise<CpaCiclo> { return this.g.fechar(id); }
}
export class ArquivarCpaCiclo implements ArquivarCpaCicloUseCase {
  constructor(private readonly g: CpaGateway) {}
  execute(id: string): Promise<CpaCiclo> { return this.g.arquivar(id); }
}
export class RelatorioSinteticoCpa implements RelatorioSinteticoCpaUseCase {
  constructor(private readonly g: CpaGateway) {}
  execute(id: string): Promise<CpaRelatorioSintetico> { return this.g.relatorioSintetico(id); }
}
export class ListCpaDimensoes implements ListCpaDimensoesUseCase {
  constructor(private readonly g: CpaGateway) {}
  execute(): Promise<CpaDimensao[]> { return this.g.listDimensoes(); }
}
